
  <!--CAROUSEL-->
<div class="carousel-container">
  <div class="bd-highlight">
    <div id="carouselIndicators" class="carousel slide"
      data-ride="carousel">
      <ol class="carousel-indicators">
        <li data-target="#carouselIndicators"
          data-slide-to="0" class="active"></li>
        <li data-target="#carouselIndicators"
          data-slide-to="1"></li>
        <li data-target="#carouselIndicators"
          data-slide-to="2"></li>
      </ol>

      <div class="carousel-inner">
        <div [ngClass]="indexOfelement == 0 ? 'carousel-item active' : 'carousel-item'" *ngFor="let image of bannerImgList;let indexOfelement=index;">
          <!--src="{{image.urlPath}}"-->
          <img class="d-block w-100" src="{{imageURL}}{{image.urlPath}}" />
         
        </div>
        
        <!--src="../../../../assets/images/carousel/Banner1-2_Explore_1200X400.png"-->
        <!--end carousel-item-->
        <!--<div class="carousel-item">
    <img class="d-block w-100 "
      src="../../../../assets/images/carousel/Banner2_Order_1200X400.png"
      alt="Second slide">
  </div>-->
        <!--end carousel-item-->
        <!--<div class="carousel-item">
    <img class="d-block w-100 "
      src="../../../../assets/images/carousel/Banner3_Tools_1200X400.png"
      alt="Third slide">
  </div>-->
        <!--end carousel-item-->
        <!--<div class="carousel-item">
    <img class="d-block w-100 "
      src="../../../../assets/images/carousel/Banner4_Help_1200X400.png"
      alt="Fourth slide">
  </div>-->
        <!--end carousel-item-->
        <!--<div class="carousel-item">
    <img class="d-block w-100 "
      src="../../../../assets/images/carousel/Banner5_Videos_1200X400.png"
      alt="Fifth slide">
  </div>-->
        <!--end carousel-item-->
      </div>
      <!--end carousel-inner-->

      <a class="carousel-control-prev"
        href="#carouselIndicators" role="button"
        data-slide="prev">
        <span class="carousel-control-prev-icon"
          aria-hidden="true"></span>
        <span class="sr-only">Previous</span>
      </a>

      <a class="carousel-control-next"
        href="#carouselIndicators" role="button"
        data-slide="next">
        <span class="carousel-control-next-icon"
          aria-hidden="true"></span>
        <span class="sr-only">Next</span>
      </a>

    </div>
    <!--end carouselIndicators-->
  </div>
  <!--end bd-highlight-->
</div>
<!--end carousel-container-->


<!--end homeIcons build_and_buy-->

<div class="row homeIconsContainer" *ngIf="isLogin">

  <div class="col-lg-3 homeIcons fade-on-hover">
    <a [routerLink]="['/build-and-buy']">
      <img src="../../../../assets/images/Home/Build & Buy Quick Link 435x180.png"
           alt="Build & Buy link" />
    </a>
  </div>
  <!--end col-->

  <div class="col-lg-3 homeIcons fade-on-hover">
    <a [routerLink]="['/faq']">
      <img src="../../../../assets/images/Home/FAQ Quick Link 435x180.png"
           alt="faq link" />
    </a>
  </div>
  <!--end col-->

  <div class="col-lg-3 homeIcons fade-on-hover">
    <a [routerLink]="['/order-inquiry']">
      <img src="../../../../assets/images/Home/Order Inquiry Link 435x180.png"
           alt="learn link" />
    </a>
  </div>
  <!--end col-->

  <div class="col-lg-3 homeIcons fade-on-hover">
    <a [routerLink]="['/manage-quote/kawneerdirect-quotes']">
      <img src="../../../../assets/images/Home/My Quotes Quick Link 435x180.png"
           alt="my_quotes link" />
    </a>
  </div>
  <!--end col-->

  <div class="col-lg-3 homeIcons fade-on-hover">
    <a [routerLink]="['/literature/news/literature-pages/18']">
      <img src="../../../../assets/images/Home/News Quick Link 435x180.png"
           alt="news link" />
    </a>
  </div>
  <!--end col-->
</div>
<!--end row-->
